export interface LocationData {
  country: string
  administrativeAreaLevel1?: string
  administrativeAreaLevel2?: string
  locality?: string
}

export interface Destination {
  id: string
  locationName: string
  locationData: LocationData
  arrivalDatetime: Date | null
}

export interface DayExclusion {
  date: Date
  breakfastProvided: boolean
  lunchProvided: boolean
  dinnerProvided: boolean
  accommodationProvided: boolean
}

export interface CostCenterAssignment {
  costCenterId: number
  percentage: number
  startDate: string
  endDate?: string
}

export interface PerDiemWizardData {
  // Step 1: Trip Details
  startDate: Date | null
  endDate: Date | null
  destinations: Destination[]

  // Step 2: Company-paid items
  dayExclusions: DayExclusion[]

  // Budget and Project
  budgetId?: number
  // projectId is actually projectWorkerId (the employee-project assignment ID)
  projectId?: number
  subprojectId?: number

  // Cost Centers
  costCenterAssignments: CostCenterAssignment[]

  // Additional Information
  description?: string
  internalReference?: string
  files: File[]

  // Employee
  employeeId?: number

  // Requester
  requesterId?: number

  tripName?: string
}

export const createEmptyDestination = (): Destination => ({
  id: crypto.randomUUID(),
  locationName: '',
  locationData: {
    country: '',
  },
  arrivalDatetime: null,
})

export const createInitialWizardData = (): PerDiemWizardData => ({
  startDate: null,
  endDate: null,
  destinations: [createEmptyDestination()],
  dayExclusions: [],
  costCenterAssignments: [],
  files: [],
})
